<router-outlet></router-outlet>
<vex-client-notice-banner *ngIf="!clientControl.isAdminRoute"></vex-client-notice-banner>

<vcs-chat-dock></vcs-chat-dock>

<vcs-wall-shortcut></vcs-wall-shortcut>
